import { Button, Text } from '@chakra-ui/react'
import { generatePath, useNavigate } from 'react-router'
import {
  StaticScreen,
  StaticScreenTitle,
  StaticScreenContent,
  StaticScreenFooter,
} from 'src/components/StaticScreen/StaticScreen'
import { Paths } from 'src/constants/paths'
import { useSelectedTrial } from 'src/features/auth/context'
import { useAccountInfo } from 'src/features/misc/hooks/useAccountInfo'

export const ForbiddenMessageScreen: React.FC = () => {
  const { trialName, hospitalName } = useAccountInfo()
  const { selectedTrial } = useSelectedTrial()
  const navigate = useNavigate()

  return (
    <StaticScreen>
      <StaticScreenTitle>ファイルを参照できません</StaticScreenTitle>
      <StaticScreenContent>
        <Text>
          このファイルは現在ログイン中の
          {trialName}
          {hospitalName ? `・${hospitalName}` : ''}
          では参照いただけません。
        </Text>
        <Text>
          参照が必要な場合は再度ログインし直して適切な試験・医療機関でお試しください。
        </Text>
      </StaticScreenContent>
      <StaticScreenFooter>
        <Button
          onClick={() =>
            navigate(
              generatePath(Paths.TrialTop, { trialUid: selectedTrial.uid }),
            )
          }
        >
          試験TOP画面へ
        </Button>
      </StaticScreenFooter>
    </StaticScreen>
  )
}
